import React from 'react';
import { BsListColumns, BsPencil, BsFileText, BsClock, BsPerson, BsShield } from 'react-icons/bs';
import { Spinner } from 'react-bootstrap';
import { Element, ContainerProgress } from './styles';
import { formatIncidentCode } from '../../../../utils/formatCodes';

const IncidentCard = ({ 
  incident, 
  onView, 
  onEdit, 
  onReport,
  isCollapsed = false,
  isGeneratingReport = false
}) => {
  const getIncidentTypeText = (type) => {
    const types = {
      VAZAMENTO_DADOS: 'Vazamento de Dados',
      ACESSO_NAO_AUTORIZADO: 'Acesso Não Autorizado',
      PERDA_DADOS: 'Perda de Dados',
      ALTERACAO_NAO_AUTORIZADA: 'Alteração Não Autorizada',
      DESTRUICAO_DADOS: 'Destruição de Dados',
      OUTROS: 'Outros'
    };
    return types[type] || type;
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const getSeverityIcon = (severity) => {
    return <BsShield className="me-1" />;
  };

  return (
    <Element id={`incident-card-${incident.id}`}>
      <ContainerProgress id={`incident-progress-${incident.id}`}>
        {/* Aqui pode ser adicionado um indicador de progresso se necessário */}
      </ContainerProgress>
      
      <div className="incident-header" id={`incident-header-${incident.id}`}>
        <div className="incident-left">
          <div className="incident-number" id={`incident-number-${incident.id}`}>
            {formatIncidentCode(incident.id)}
          </div>
          
          <div className="incident-date" id={`incident-date-${incident.id}`}>
            <BsClock className="me-1" />
            {formatDate(incident.incidentDate)}
          </div>
        </div>
        
        <div className="badges-container" id={`incident-badges-${incident.id}`}>
          <span className={`badge badge-severity ${incident.severityLevel}`}>
            {getSeverityIcon(incident.severityLevel)}
            {incident.severityLevel}
          </span>
          <span className={`badge badge-status ${incident.status}`}>
            {incident.status}
          </span>
        </div>
      </div>

      <h1 id={`incident-title-${incident.id}`}>
        {incident.title}
      </h1>

      <div className="incident-description" id={`incident-description-${incident.id}`}>
        {incident.description.length > 100 
          ? `${incident.description.substring(0, 100)}...` 
          : incident.description
        }
      </div>

      <div className="incident-details" id={`incident-details-${incident.id}`}>
        <div className="detail-item">
          <span className="label">Tipo:</span>
          <span className="value">{getIncidentTypeText(incident.incidentType)}</span>
        </div>
        
        {incident.dataSubjectsCount > 0 && (
          <div className="detail-item">
            <span className="label">Titulares:</span>
            <span className="value">{incident.dataSubjectsCount}</span>
          </div>
        )}
        
        {incident.dpo && (
          <div className="detail-item">
            <span className="label">
              <BsPerson className="me-1" />
              DPO:
            </span>
            <span className="value">{incident.dpo.name}</span>
          </div>
        )}
        
        {incident.dataCategories && incident.dataCategories.length > 0 && (
          <div className="detail-item">
            <span className="label">Categorias:</span>
            <span className="value">{incident.dataCategories.slice(0, 2).join(', ')}</span>
          </div>
        )}
      </div>

      <div className="actions-container" id={`incident-actions-${incident.id}`}>
        <button
          className="action-button secondary"
          onClick={() => onView(incident.id)}
          id={`view-incident-${incident.id}`}
          title="Detalhes do incidente"
        >
          <BsListColumns />
          Detalhes
        </button>
        <button
          className="action-button secondary"
          onClick={() => onEdit(incident.id)}
          id={`edit-incident-${incident.id}`}
          title="Editar incidente"
        >
          <BsPencil />
          Editar
        </button>
        
        <button
          className="action-button info"
          onClick={() => onReport(incident.id)}
          id={`report-incident-${incident.id}`}
          title="Gerar relatório PDF"
          disabled={isGeneratingReport}
          style={{ opacity: isGeneratingReport ? 0.7 : 1 }}
        >
          {isGeneratingReport ? (
            <>
              <Spinner
                animation="border"
                size="sm"
                style={{
                  marginRight: 8,
                  width: '14px',
                  height: '14px',
                }}
              />
              Gerando
            </>
          ) : (
            <>
              <BsFileText />
              Relatório do Incidente
            </>
          )}
        </button>
      </div>
    </Element>
  );
};

export default IncidentCard;
